import { compose, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { reducer } from './reducer';
import { composeWithDevTools } from 'redux-devtools-extension';

export default (props) => {
	let errors = {}
  let initialFormData = {
    formName: "WarrantyTransfer",
    preferredContactMethods: [],
    country: props.country || 'US',
    countrySelected: 'US',
    ownerCountrySelected: 'US',
    ownerAddressSameAsProperty: true,
    proofOfRoofPurchase: [],
    proofOfTransferCard: [],
    selections: 'suggested',
    closeDateMonth: "",
    propertyAddress: {
      street: null,
      streetLine2: null,
      city: null,
      state: null,
      zip: null
    },
  }

	const initialState = {
		railsProps: props,
		step: 1,
		formData: initialFormData,
		appData: {},
		appErrors: errors,
		dataComplaints: {},
		showComplaints: false,
		isFetching: false,
    completedSteps: { 0: true },
    metadata: {},
    showModal: false,
    overSixtyDays: false,
    notClosedYet: false
	};

  const composedStore = compose(
		composeWithDevTools(applyMiddleware(thunkMiddleware))
	);
	const storeCreator = composedStore(createStore);
	const store = storeCreator(reducer, initialState);

  return store
};
